export const PREVIEW_MARGIN = 40;
export const ENLARGED_MARGIN = 140;
